<div class="container" fxLayout="row">
  <optsol-ngx-login-form class="os-m-auto" (formSubmit)="attempt($event)" [disableSubmitButton]="false" [disableAutoComplete]="true" fxFlex="40%">
      <img brandImage [src]="environmentSettings.portalLogoUrl" width="50%" />
      <span title class="mat-h2">{{environmentSettings.portalName || 'Customer Portal'}}</span>
      <img poweredByImage [src]="environmentSettings.poweredByUrl" />
      <ng-container links>
          <a [routerLink]="['/forgot-password']">Forgot Password?</a>
      </ng-container>
  </optsol-ngx-login-form>
</div>
